import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import modules from './modules'
import service from '@/services'
import * as types from './mutation-type'
import generator from './generator'
import router, { otherRouters, layoutRoute, specialRouters, microRoute, defaultRoutes } from '@/router'
import { isSpecialChannel } from '@/utils'
import VueRouter from 'vue-router'

Vue.use(Vuex)

// state
const state = {
  commonData: {}, // (storage.getItem('commonData') && JSON.parse(storage.getItem('commonData'))) || {},
  activedData: {},
  keepIncludes: [],
  dynamicRoutes: [],
  currentPageNum: 0
}

// getters
const getters = {
  commonData: state => state.commonData,
  activedData: state => state.activedData,
  keepIncludes: state => state.keepIncludes,
  dynamicRoutes: state => state.dynamicRoutes,
  currentPageNum: state => state.currentPageNum
}

// actions
const actions = {
  setCommon: ({commit}, payload) => {
    return service.dataCommit(commit, payload, types.COMMIT_PURE_DATA)
  },
  resetCommon: ({commit}, payload) => {
    return service.dataCommit(commit, payload, types.RESET_COMMIT_PURE_DATA)
  },
  setActive: ({commit}, payload) => {
    return service.dataCommit(commit, payload, types.SET_ACTIVATED_DATA)
  },
  setIncludes: ({commit}, payload) => {
    return service.dataCommit(commit, payload, types.SET_KEEPALIVE_INCLUDES)
  },
  changeRoutes: ({commit}, payload) => {
    let layout = [...layoutRoute]
    // console.log('🚀 ~ file: index.js:46 ~ isSpecialChannel:', isSpecialChannel())
    if (isSpecialChannel()) {
      const children = layoutRoute[0].children
      layoutRoute[0].children = [...layoutRoute[0].children, ...specialRouters]
      layout.children = [...children, ...specialRouters]
    } else {
      layout = [...layoutRoute, ...otherRouters]
    }
    payload = [...layout, microRoute]
    // console.log('🚀 ~ file: index.js:54 ~ payload:', payload)
    return new Promise((resolve, reject) => {
      commit('changeRoutes', payload)
      resolve(payload)
    })
  },
  resetRoutes: ({commit}) => {
    commit('resetRoutes')
  },
  setCurrentPage: ({ commit }, payload) => {
    commit('setCurrentPage', payload)
  }
}

// mutations
const mutations = {
  [types.COMMIT_PURE_DATA] (state, data) {
    if (data.value || data.key) {
      state.commonData[data.key || 'nokey'] = data.value === undefined ? data : data.value
    }
  },
  [types.RESET_COMMIT_PURE_DATA] (state) {
    // state = {}
    state.customer.CUSTOMER_LOGINCUSTOMER = {}
    state.commonData.alertClose = ''
    /* Object.keys(state).forEach(key => {
      console.log('key=', key)
      if (key === 'customer') {
        Vue.delete(state, key)
      }
    }) */
  },
  [types.SET_ACTIVATED_DATA] (state, data) {
    state.activedData = data.value === undefined ? (data || '') : data.value
  },
  [types.SET_KEEPALIVE_INCLUDES] (state, data) {
    state.keepIncludes = data || []
  },
  changeRoutes (state, data) {
    state.dynamicRoutes = data || []
    router.addRoutes(data)
    router.options.routes = [...router.options.routes, ...data]
  },
  resetRoutes () {
    const vueRouter = new VueRouter({
      mode: 'history',
      routes: [...defaultRoutes]
    })
    router.options.routes = [...defaultRoutes]
    router.matcher = vueRouter.matcher
  },
  setCurrentPage (state, data) {
    state.currentPageNum = data
  }
}

const merge = require('webpack-merge')
const generatorModules = merge.smart(generator, modules)

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: generatorModules,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js